// components/auth/ProtectedRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * SSR-safe wrapper for useLocation.
 * During SSR there is no Router context, so useLocation throws.
 * Returns null during SSR; the protect middleware handles auth server-side.
 */
function useSafeLocation() {
    try {
        return useLocation();
    } catch {
        return null;
    }
}

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useSelector((state) => state.auth);
    const location = useSafeLocation();

    // During SSR (no Router context), auth is handled by protect middleware
    if (!location) {
        return children;
    }

    // Show loading indicator while checking authentication
    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Render the protected component
    return children;
};

export default ProtectedRoute;
